module.exports = __webpack_public_path__ + "img/rar.4a92085b.svg";